module.exports = __webpack_public_path__ + "img/skin_active_menu_type_block.7e1a4644.png";